<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.reservation.actions.noShow.title')"
    :info="info"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('components.reservation.actions.noShow.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Reservation } from '~/_api/models/reservation'

interface Props {
  reservation: Reservation
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:reservation', value: Reservation): void
  (e: 'update:loading', value: boolean): void
  (e: 'update'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.reservation.actions.noShow.info')
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const reservation = props.reservation as any
    const isAttendee = reservation.idReservationCustomer != null
    const reservationId = reservation.idReservation?.toString()
    const reservationCustomerId = reservation.idReservationCustomer?.toString()
    const response = isAttendee
      ? await $api.reservationCustomer.didNotShow(reservationCustomerId)
      : await $api.reservation.didNotShow(reservationId)

    if (response.data) {
      emit('update:reservation', response.data)
      emit('update:loading', false)
      emit('update')

      $notification.toast({
        title: $i18n.t('components.reservation.actions.noShow.success'),
        text: $i18n.t('components.reservation.actions.noShow.successInfo', { name: (response.data as any).customer?.displayName }),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
